var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSearch24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_search24x24",
    transform: "translate(-3.464 -3.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M16.735,14.582l-3.944-3.965a6.29,6.29,0,0,0,.175-8.085A6.836,6.836,0,0,0,4.834.618,6.4,6.4,0,0,0,1.139,7.874a6.64,6.64,0,0,0,6.533,5.055A6.778,6.778,0,0,0,11.5,11.759l3.973,3.991a.894.894,0,0,0,1.234.024A.823.823,0,0,0,16.735,14.582ZM7.671,1.69a4.862,4.862,0,0,1,4.945,4.778A4.862,4.862,0,0,1,7.67,11.243,4.862,4.862,0,0,1,2.728,6.462,4.868,4.868,0,0,1,7.671,1.69Z",
    transform: "translate(2.485 3.558)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSearch24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_search24x24.9bf5743f018c4bd3d8ff589c388c6a1e.svg";